import type { ExternalJustificatif } from '@cpce/shared';
import { ExternalLink, Eye } from 'lucide-react';
import { Button } from './Button';
import { Modal } from './Modal';
import { ModalButton } from './ModalButton';

interface DocumentViewerButtonProps {
  justificatif: ExternalJustificatif;
}

function getPathname(url: string): string {
  try {
    return new URL(url).pathname.toLowerCase();
  } catch {
    return url.toLowerCase();
  }
}

function isImageUrl(url: string): boolean {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
  const pathname = getPathname(url);
  return imageExtensions.some((ext) => pathname.endsWith(ext));
}
export function DocumentViewerButton(props: DocumentViewerButtonProps) {
  const { justificatif } = props;

  const renderDocument = () => {
    if (isImageUrl(justificatif.url)) {
      return (
        <img
          src={justificatif.url}
          alt={justificatif.type}
          className="max-w-full max-h-[70vh] object-contain mx-auto"
        />
      );
    }

    return (
      <iframe
        src={justificatif.url}
        title={justificatif.type}
        className="w-full h-[70vh] border-0"
      />
    );
  };

  return (
    <ModalButton
      modal={(open, closeModal) => (
        <Modal open={open} onOpenChange={closeModal} title={justificatif.type} windowWidth="large">
          <div className="flex flex-col gap-4">
            {renderDocument()}
            <a
              href={justificatif.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline flex items-center gap-1 self-end"
            >
              Ouvrir dans un nouvel onglet
              <ExternalLink className="size-4" />
            </a>
          </div>
        </Modal>
      )}
      button={(triggerModal) => (
        <Button className="text-primary text-lg" onClick={triggerModal}>
          <Eye className="size-6" />
          Voir
        </Button>
      )}
    />
  );
}
